import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

const dict = {
  home: { id: 'Beranda', en: 'Home' },
  search: { id: 'Cari di situs ini...', en: 'Search this site...' },
  learnMore: { id: 'Selengkapnya', en: 'Learn More' },
  readMore: { id: 'Baca Selengkapnya', en: 'Read More' },
  latestNews: { id: 'Berita Terkini', en: 'Latest News' },
  ourPriorities: { id: 'PRIORITAS KAMI', en: 'OUR PRIORITIES' },
  foundationLeadership: { id: 'Pengurus YPPSDP', en: 'YPPSDP Leadership' },
  nationalAgency: { id: 'YAYASAN PENGEMBANGAN', en: 'FOUNDATION FOR DEVELOPMENT' },
  officialSiteBanner: { id: 'Situs resmi Yayasan YPPSDP', en: 'Official website of YPPSDP Foundation' },
  howToRecognize: { id: 'Cara mengenalinya', en: 'How to recognize it' },
  headOffice: { id: 'KANTOR PUSAT', en: 'HEAD OFFICE' },
  address: { id: 'JAKARTA • INDONESIA', en: 'JAKARTA • INDONESIA' },
  motto: { id: 'INTEGRITAS • PROFESIONAL • PENGABDIAN', en: 'INTEGRITY • PROFESSIONAL • DEDICATION' },
  filter: { id: 'Filter', en: 'Filter' },
  all: { id: 'SEMUA', en: 'ALL' },
  published: { id: 'Dipublikasikan', en: 'Published' },
  by: { id: 'Oleh', en: 'By' },
  gallery: { id: 'Galeri Foto', en: 'Photo Gallery' },
  relatedNews: { id: 'Berita Terkait', en: 'Related News' },
  backToNews: { id: 'Kembali ke Berita', en: 'Back to News' },
  aboutUs: { id: 'TENTANG YPPSDP', en: 'ABOUT YPPSDP' },
  news: { id: 'BERITA', en: 'NEWS' },
  leadership: { id: 'Pimpinan', en: 'Leadership' },
  fullBio: { id: 'Biografi Lengkap', en: 'Full Biography' },
  quickFacts: { id: 'Fakta Singkat', en: 'Quick Facts' },
  vision: { id: 'VISI', en: 'VISION' },
  mission: { id: 'MISI', en: 'MISSION' },
  coreValuesTitle: { id: 'Nilai-Nilai Inti', en: 'Core Values' },
  organizationStructure: { id: 'Struktur Organisasi', en: 'Organization Structure' },
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('yppsdp_lang') || 'id');

  useEffect(() => {
    localStorage.setItem('yppsdp_lang', lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => dict[key]?.[lang] || key;
  const tv = (obj) => (obj && typeof obj === 'object' && obj[lang] !== undefined ? obj[lang] : obj);
  const toggle = () => setLang((l) => (l === 'id' ? 'en' : 'id'));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t, tv }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
